import { Flex } from '@chakra-ui/react';
import { Button } from '@morressier/alembic';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormValues } from './AssignMembers';

type FooterActionsProps = {
  onClose: () => void;
  isLoading: boolean;
  onSave: () => void;
};

export default memo(function FooterActions({
  onClose,
  isLoading,
  onSave
}: FooterActionsProps) {
  const { watch } = useFormContext<FormValues>();
  const assignments = watch('assignments');

  const selectedCount = Object.values(assignments ?? {}).filter(
    member => member?.selected
  )?.length;

  return (
    <Flex justifyContent="flex-end" gap={2} flexWrap="wrap">
      <Button
        variant="secondary"
        onClick={onClose}
        isDisabled={isLoading}
        disabled={isLoading}
      >
        Exit Without Adding
      </Button>

      <Button
        type="button"
        onClick={onSave}
        variant="primary"
        isLoading={isLoading}
        disabled={isLoading || !selectedCount}
      >
        Assign Members {selectedCount > 0 && `(${selectedCount})`}
      </Button>
    </Flex>
  );
});
